module.exports = __webpack_public_path__ + "img/menu_dashboard.fcb57536.svg";